import { Map } from 'immutable'
import { combineReducers } from 'redux-immutable'
import { handleActions, combineActions } from 'redux-actions'
import * as actions from './actions'
import * as UserActions from 'app/modules/user/actions'

const status = handleActions({
  [combineActions(
    actions.fetchUserPropertiesPending,
    actions.fetchUserPropertiesCancelled,
    actions.fetchUserPropertiesFailed,
    actions.receiveUserProperties,
  )]: (state, action) =>
    state.set('fetch', action.type),

  [combineActions(
    actions.updateUserPropertiesPending,
    actions.updateUserPropertiesCancelled,
    actions.updateUserPropertiesFailed,
    actions.receiveUserProperties,
  )]: (state, action) =>
    state.set('update', action.type),

}, Map({
  fetch: null,
  update: null,
}))

const data = handleActions({
  [actions.receiveUserProperties]: (state, action) => {
    return action.payload
  },

  [actions.updateUserPropertiesPending]: (state, action) => {
    return state.merge(action.payload)
  },

  [UserActions.turnOffManualAwaySuccess]: (state) => {
    return state.merge({ 'auto-away': true })
  },
  [actions.userAtConversationLimitUpdate]: (state, action) => {
    return state.merge({ 'atConversationLimit': action.payload })
  },
}, Map())

const usersByPropertyName = handleActions({
  [actions.fetchUsersByPropertyNameSuccess]: (state, action) => {
    return state.merge(action.payload)
  },
}, Map())

export default combineReducers({
  status,
  data,
  usersByPropertyName,
})



// WEBPACK FOOTER //
// ./src/scripts/app/modules/user/properties/reducer.js